import React, { useEffect, useState } from 'react';
import { Banknote } from 'lucide-react';
import api from '@/lib/api';

const won = (n) => `${(Number(n) || 0).toLocaleString('ko-KR')}원`;

export const DepositInfo = ({ orderId }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get(`/orders/${orderId}/deposit-info`).then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, [orderId]);
  const pending = rows.filter((r) => r.status === 'payment_pending');
  if (pending.length === 0) return null;
  return (
    <div className="rounded-2xl border border-[#FF3B30]/30 bg-[#FF3B30]/5 p-4 space-y-3" data-testid="deposit-info">
      <p className="text-sm font-black inline-flex items-center gap-1.5"><Banknote size={15} className="text-[#FF3B30]" /> 입금 안내</p>
      {pending.map((r) => (
        <div key={r.seller_order_id} className="text-sm space-y-0.5" data-testid={`deposit-info-${r.seller_order_id}`}>
          <p className="font-bold">{r.seller_name}</p>
          {r.account_number ? (
            <p data-testid={`deposit-account-${r.seller_order_id}`}>{r.bank} {r.account_number} · 예금주 {r.account_holder}</p>
          ) : <p className="text-gray-500" data-testid={`deposit-account-missing-${r.seller_order_id}`}>{r.snapshot_missing ? '주문 당시 입금계좌 정보가 저장되지 않은 주문입니다. 판매자에게 입금계좌를 확인해주세요.' : '판매자 입금 계좌가 아직 등록되지 않았습니다. 판매자에게 문의해주세요.'}</p>}
          <p>입금액 <strong className="text-[#FF3B30]" data-testid={`deposit-amount-${r.seller_order_id}`}>{won(r.amount)}</strong> · 입금자명 <strong>{r.depositor_name || '-'}</strong></p>
          <p className="text-[11px] text-gray-500">{r.auto_confirm ? '입금자명과 금액이 일치하면 자동으로 입금확인됩니다.' : '판매자가 입금을 확인하면 결제완료로 바뀝니다.'}</p>
        </div>
      ))}
      {pending.length > 1 && <p className="text-[11px] text-gray-500">판매자마다 계좌와 금액이 달라 각각 따로 입금해주세요.</p>}
      <p className="text-[11px] text-amber-700" data-testid="deposit-delay-notice">무통장입금 후 결제완료 처리까지 시간이 걸릴 수 있습니다. 입금자명과 입금금액을 정확히 확인해 주세요.</p>
    </div>
  );
};

export default DepositInfo;
